import { isEmptyArray } from './is-empty-array';

export const isNotEmptyArray = <T>(predictable: T[]): predictable is T[] => {
  return !isEmptyArray(predictable);
};
